<template>
  <div class="friends_wrap">

    <img class="title" src="https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/friends_title.png" alt="">

    <div v-if="all_friends && all_friends.length > 0">
      <div v-for="(item,index) in show_friends" class="single_friend">
        <img :src="item.avatar || '//vipcdn.mgtv.com/mrdb/unionvip/imgs/mrtx1.png'" class="avatar">
        <div class="middle">
          <div class="nickname">{{item.nickname}}</div>
          <div class="time">{{item.recv_time}}</div>
          <!--<div class="time">{{friendlyTime(item.recv_time)}}</div>-->
        </div>
        <div class="gift">
          领取成功
        </div>
      </div>
      <div v-if="show_friends.length < all_friends.length" @click.prevent="show_all_friends" class="tip"
           style="text-decoration: underline">
        查看全部
      </div>
    </div>
    <div v-else class="tip">
      就等你了～
    </div>
  </div>
</template>


<script>

  import click_handler from '../tools/mgtv/click'
  import {friendlyTime} from '../tools/time-format'

  export default {
    name: 'Friends',
    props: {},
    data() {
      return {
        gact: window.gact,
        show_all: false,
      }
    },
    computed: {
      user() {
        return window.$bus.user
      },
      all_friends() {
        if (!window.$bus.zp_info) {
          return [];
        }
        return window.$bus.zp_info.recv_list ||   []
      },
      show_friends() {
        if (this.show_all) {
          return this.all_friends
        } else {
          return this.all_friends.slice(0, 5)
        }
      },
    },
    methods: {
      show_all_friends() {
        this.show_all = true;
      },
      friendlyTime(timeStr) {
        return friendlyTime(timeStr)
      }
    },
    mounted() {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

  @import "../share/mixins.styl"
  @import "../share/1px.styl"

  .friends_wrap
    position relative
    margin 0 .2rem
    padding .3rem 0
    background #211435
    .title
      margin 0 auto
      display block
      width 3.88rem
      margin-bottom .1rem

    .single_friend
      color white
      margin .22rem .5rem
      position relative
      height .8rem
      display flex
      flex-direction row

      .avatar
        width .8rem
        height @width
        border-radius @width
        display inline-block
        margin-right .2rem

      .middle
        width 3.6rem
        height .8rem
        display flex
        flex-direction column
        justify-content center

        .nickname
          font-size .28rem
          color white
          max-width 3.6rem
          ellipsis()

        .time
          font-size .24rem
          color white
      .gift
        position absolute
        right 0
        font-size .28rem
        color white
        height .8rem
        line-height @height
    .tip
      width 100%
      text-align center
      font-size .28rem
      color white
      padding .1rem 0

</style>



// WEBPACK FOOTER //
// src/components/Friends.vue